import React from 'react';

const KeyInsights = ({ selectedRegion, selectedCity, dateRange, showLocations, showProducts, showApps }) => {
  // In a real app, these insights would be generated based on the filtered data
  // This is a mock implementation with static insights
  
  // Helper function to generate location text based on filters
  const getLocationText = () => {
    if (selectedRegion === 'global') return 'all regions';
    return selectedCity ? `${selectedCity}, ${selectedRegion}` : selectedRegion;
  };
  
  // Helper function to generate source text based on filters
  const getSourceText = () => {
    const sources = [];
    if (showLocations) sources.push('Locations');
    if (showProducts) sources.push('Products');
    if (showApps) sources.push('Apps');
    
    if (sources.length === 3) return 'all sources';
    if (sources.length === 0) return 'no sources';
    return sources.join(' and ');
  };
  
  // Mock insights - these would be AI-generated in a real implementation
  const insights = [
    {
      title: 'Emerging Trend',
      text: `Customer service issues have increased by 14% in ${getLocationText()}, particularly related to response times and problem resolution.`,
      recommendation: 'Consider implementing additional staff training focused on response efficiency and resolution protocols.'
    },
    {
      title: 'Positive Highlight',
      text: `Product quality mentions are overwhelmingly positive across ${getSourceText()}, with 78% expressing satisfaction with durability and performance.`,
      recommendation: 'Highlight product quality in marketing materials and continue current quality control processes.'
    },
    {
      title: 'Attention Required',
      text: `Delivery experience has become a frequent negative topic in recent reviews, mentioned in 23% of negative feedback.`,
      recommendation: 'Review current delivery partners and processes, with focus on tracking transparency and delivery timeframes.'
    },
    {
      title: 'Cross-Platform Insight',
      text: `User interface complaints are 3x higher in mobile app reviews compared to other platforms.`,
      recommendation: 'Prioritize UI/UX improvements in the next app update cycle, focusing on navigation and checkout process.'
    }
  ];
  
  return (
    <div className="bg-white rounded-lg shadow-sm p-4">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-medium text-gray-800">Key Insights</h2>
        <span className="text-xs text-gray-500">AI-generated analysis</span>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {insights.map((insight, index) => (
          <div 
            key={index} 
            className="border border-gray-100 rounded-lg p-4 hover:shadow-sm transition-shadow"
          >
            <div className="flex items-center mb-2">
              {index === 0 && <span className="w-2 h-2 rounded-full bg-orange-500 mr-2"></span>}
              {index === 1 && <span className="w-2 h-2 rounded-full bg-green-500 mr-2"></span>}
              {index === 2 && <span className="w-2 h-2 rounded-full bg-red-500 mr-2"></span>}
              {index === 3 && <span className="w-2 h-2 rounded-full bg-blue-500 mr-2"></span>}
              <h3 className="font-medium text-sm">{insight.title}</h3>
            </div>
            <p className="text-sm text-gray-700 mb-2">{insight.text}</p>
            <div className="bg-blue-50 p-2 rounded">
              <p className="text-xs text-blue-800">
                <span className="font-medium">Recommendation:</span> {insight.recommendation}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KeyInsights;